/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import "../App.css"; // Tailwind and other styles
import { AppDispatch } from "../app/store";
import logo from "../assets/logo-small.png";
import MyMarkdownComponent from "../component/MyMarkdownComponent";
import ThemeSwitch from "../component/ThemeSwitch";
import { setTheme } from "../features/themeSlice";
import { apiService } from "../services/apiService";
import { RootState } from "../types";
import { getCookieToken, setCookieToken } from "../utils";

const SharedChat: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const [shareContent, setShareContent] = useState<any[]>([]);
  const { chatId } = useParams();
  const [isLoading, setIsLoading] = useState(false);
  // Type the selector hook properly
  const theme = useSelector((state: RootState) => state.theme.theme);
  useEffect(() => {
    const savedTheme = getCookieToken("theme");
    if (savedTheme && (savedTheme === "light" || savedTheme === "dark")) {
      dispatch(setTheme(savedTheme));
    } else {
      dispatch(setTheme("light")); // Default to light theme
    }
  }, [dispatch]);

  useEffect(() => {
    document.documentElement.className = theme;
    setCookieToken("theme", theme);
    chatId && fetchShareLink(Number(chatId));
    !chatId &&
      toast.error("Chat Id not found", {
        className: "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });
  }, [chatId]);

  const fetchShareLink = async (genId: number) => {
    setIsLoading(true);
    try {
      const response = await apiService.shareChat(genId); // Call the API service
      if (response?.status === 200) {
        const shareData = (response as any)?.data?.data;
        setShareContent(JSON.parse(shareData)?.reverse());
      }
    } catch (error) {
      toast.error("Chat not found", {
        className: "md:!bg-[#FD7272]/20 !bg-[#FD7272]/100 dark:!text-white dark:text-[#191919] !shadow-none",
        duration: 2000,
      });
    }
    setIsLoading(false);
  };

  const TypingIndicator = () => (
    <div className="flex justify-start items-center space-x-2 pt-2">
      <div className="w-3 h-3 bg-[#d1d5db57] rounded-full animate-bounce"></div>
      <div className="w-3 h-3 bg-[#d1d5db57] rounded-full animate-bounce-dots "></div>
      <div className="w-3 h-3 bg-[#d1d5db57] rounded-full animate-bounce"></div>
    </div>
  );
  return (
    <div
      className={`flex px-3 w-full lg:mx-6 my-5 flex-col relative bg-chatLightBg backdrop-blur-[20px] dark:bg-[linear-gradient(119deg,#091B27_0%,#10324B_100%)] dark:bg-opacity-80 dark:backdrop-blur-[42px] rounded-3xl overflow-y-auto py-20 ${
        isLoading ? "justify-center items-center" : "justify-start items-start"
      }`}
    >
      {isLoading ? (
        <div className="dot-loader scale-150"></div>
      ) : (
        <div className={`2xl:max-w-[60%] max-w-[80%] mx-auto h-full`}>
          {shareContent.length > 0 && (
            <div className="flex justify-end pb-10">
              <ThemeSwitch className="!mt-0" />
            </div>
          )}
          {!shareContent.length ? (
            <div className="flex flex-col items-center justify-center h-full p-4 w-full">
              <h3 className="text-5xl">No chat Found</h3>
            </div>
          ) : (
            <div className="pb-10">
              {Array.isArray(shareContent) &&
                shareContent.length > 0 &&
                shareContent.map((msg: any) => (
                  <div
                    key={msg.id}
                    className={`flex items-start w-full ${
                      msg.role === "You" ? "justify-end" : "justify-start"
                    }`}
                  >
                    {msg.role !== "You" && (
                      <img
                        src={logo}
                        alt={msg.role}
                        className="w-7 h-7 rounded-full mr-2 mt-4 p-1 bg-white"
                      />
                    )}
                    <div
                      className={`py-0 md:px-6 px-2 rounded-[15px] max-w-full w-fit lg:text-lg md:text-base text-sm ${
                        msg.role === "You"
                          ? "bg-[#e0e0e0]/90 backdrop-blur-[20px] dark:bg-[#091B27]/80 text-chatLightText dark:text-chatDarkText"
                          : "bg-transparent dark:bg-transparent text-chatLightText dark:text-chatDarkText"
                      }`}
                    >
                      {msg.role === "AI" && !msg.content && <TypingIndicator />}
                      <MyMarkdownComponent msg={msg.content} />
                    </div>
                  </div>
                ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default SharedChat;
